import { Tooltip } from 'antd';
import moment from 'moment';
import { useMemo } from 'react';
import { classes } from 'src/utils/classes';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Shows time from the date with a tooltip to check the date.
 */
export var DateFromNow = function DateFromNow(_ref) {
  var date = _ref.date,
      small = _ref.small;
  return useMemo(function () {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: date && /*#__PURE__*/_jsx(Tooltip, {
        title: moment(date).format('DD/MM/YYYY HH:mm'),
        children: /*#__PURE__*/_jsx(Container, {
          className: classes({
            'date-from-now': true,
            small: small
          }),
          children: moment(date).fromNow()
        })
      })
    });
  }, [date]);
};
var Container = styled.span.withConfig({
  displayName: "DateFromNow__Container",
  componentId: "sc-ko7xrv-0"
})(["&.small{font-size:0.9em;}"]);